  document.addEventListener('DOMContentLoaded', function () {
    // Initialize promo grid sorting
    const promoGrids = document.querySelectorAll('.promo-grid--inner');
    if (promoGrids.length === 0) return;

    // Store original order
    const gridOriginals = Array.from(promoGrids).map((grid) => ({
      grid: grid,
      originalBlocks: Array.from(grid.querySelectorAll('.promo-block')),
    }));

    // Set up sort selectors
    document.querySelectorAll('#promo-sort').forEach((sortSelect) => {
      sortSelect.addEventListener('change', function () {
        const closestGrid = findClosestGrid(this);
        if (!closestGrid) return;

        const gridData = gridOriginals.find((data) => data.grid === closestGrid);
        if (!gridData) return;

        const blocks = Array.from(closestGrid.querySelectorAll('.promo-block'));

        switch (this.value) {
          case 'default':
            sortBlocks(closestGrid, gridData.originalBlocks);
            break;

          case 'title-asc':
            sortBlocks(
              closestGrid,
              blocks.sort((a, b) => getCollectionHandle(a).localeCompare(getCollectionHandle(b)))
            );
            break;

          case 'title-desc':
            sortBlocks(
              closestGrid,
              blocks.sort((a, b) => getCollectionHandle(b).localeCompare(getCollectionHandle(a)))
            );
            break;

          case 'date-desc':
            sortBlocks(
              closestGrid,
              blocks.sort((a, b) => getCollectionDate(b) - getCollectionDate(a))
            );
            break;

          case 'date-asc':
            sortBlocks(
              closestGrid,
              blocks.sort((a, b) => getCollectionDate(a) - getCollectionDate(b))
            );
            break;
        }
      });
    });

    // Helper functions
    function getCollectionHandle(block) {
      return (block.dataset.collectionHandle || '').toLowerCase();
    }

    function getCollectionDate(block) {
      return parseInt(block.dataset.dateAdded) || 0;
    }

    function findClosestGrid(element) {
      let current = element;
      while (current && !current.classList.contains('promo-grid--section')) {
        current = current.parentElement;
      }
      return current ? current.querySelector('.promo-grid--inner') : document.querySelector('.promo-grid--inner');
    }

    function sortBlocks(grid, sortedBlocks) {
      grid.innerHTML = '';
      sortedBlocks.forEach((block) => grid.appendChild(block));
    }
  });
